import React from 'react'

export default ({ content }) => (
  <div
    className="event-media media-text"
    dangerouslySetInnerHTML={{ __html: content }}
  />
)
